// extracted by mini-css-extract-plugin
export default {"footerContainer":"SystemPromptModal__footerContainer___PLFd_","skeleton-loading":"SystemPromptModal__skeleton-loading___Rh3AA"};